exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.default-slider .slider-inner.space-top-lg[data-v-7a2a999b]{\n  top:248px !important;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/modules/courier-dashboard/entityDetails.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;CACtB","file":"entityDetails.vue","sourcesContent":["\n.default-slider .slider-inner.space-top-lg[data-v-7a2a999b]{\n  top:248px !important;\n}\n"],"sourceRoot":""}]);

// exports
